import { render } from "./pnc_investigations.vue?vue&type=template&id=19f53dc4&scoped=true"
import script from "./pnc_investigations.vue?vue&type=script&lang=js"
export * from "./pnc_investigations.vue?vue&type=script&lang=js"

import "./pnc_investigations.vue?vue&type=style&index=0&id=19f53dc4&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f53dc4"]])

export default __exports__